import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="bd-libraire-bookseller-search"
// Debounced bookseller-name search: updates the suggestions Turbo Frame `src`
// as the admin types, and fills both the visible name field and the hidden
// bookseller_id field once a suggestion is picked. Modelled on
// author_autocomplete_controller.js, but that controller only carries a name
// — this form also needs the bookseller's id.
export default class extends Controller {
  static targets = ["input", "idInput", "suggestions"]
  static values = { url: String, minLength: { type: Number, default: 3 } }

  initialize() {
    this.search = debounce(this.search.bind(this), 300);
  }

  search() {
    const query = this.inputTarget.value.trim();

    if (query.length < this.minLengthValue) {
      this.clearSuggestions();
      return;
    }

    // The url value already carries a `context` param, so append rather than
    // starting a fresh query string.
    const separator = this.urlValue.indexOf("?") === -1 ? "?" : "&";
    this.suggestionsTarget.src = this.urlValue + separator + "q=" + encodeURIComponent(query);
  }

  choose(event) {
    this.inputTarget.value = event.params.name;
    this.idInputTarget.value = event.params.id;
    this.clearSuggestions();
    // Setting .value programmatically does not fire a native "change" event,
    // and the surrounding form listens for "change" (delegated, see
    // bd_libraire_form_controller.js) to refresh the live preview — dispatch
    // one so picking a suggestion refreshes it same as any other field edit.
    this.idInputTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  clearSuggestions() {
    this.suggestionsTarget.removeAttribute("src");
    this.suggestionsTarget.innerHTML = "";
  }
}
